<template>
    <div style="">
        <hd-header></hd-header>
        <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 50px;padding-top: 50px;">
            <div style="width:1200px">
                <el-container style="padding-top: 50px;">
                    <el-aside width="220px">
                        <hd-aside></hd-aside>
                    </el-aside>
                    <el-main style="padding-top: 0;padding-bottom: 0;">
                        <el-card shadow="never" style="border: 0;padding-bottom: 20px;">
                            <p class="pTitle">个人信息</p>
                            <el-form label-position="right" label-width="100px">
                                <el-form-item label="真实姓名:" class="itemForm"><span>{{ realName }}</span></el-form-item>
                                <el-form-item label="手机号:" class="itemForm"><span>{{ mobile }}</span></el-form-item>
                                <el-form-item label="身份证号:" class="itemForm"><span>{{ idCard }}</span></el-form-item>
                            </el-form>
                            <p class="pTitle">认证信息</p>
                            <sub-teacher-info save="/user-teacher-cer" style="margin-top: 1.5em;"></sub-teacher-info>
                        </el-card>
                    </el-main>
                </el-container>
            </div>
        </div>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
import HdHeader from '../public/Header.vue'
import HdFooter from '../public/FooterLogined.vue'
import HdAside from '../public/Aside.vue'
import SubTeacherInfo from '../public/sub/SubTeacherInfo.vue'

export default {
    name: 'UserTeacherInfo',
    components: {
        HdHeader,
        HdFooter,
        HdAside,
        SubTeacherInfo
    },
    created () {
        this.getUserInfo()
    },
    data () {
        return {
            realName: '',
            mobile: '',
            idCard: ''
        }
    },
    methods: {
        getUserInfo () {
            let that = this
            this.$ajax.get('/api/user/get').then(function (res) {
                that.realName = res.data.real_name
                that.mobile = res.data.mobile
                that.idCard = res.data.id_number
            })
        }
    }
}
</script>

<style>
body {
    background-color: #F8F8F8;
}

.pTitle {
    border-bottom: 1px solid #d6d6da;
    padding-bottom: 10px;
}

.itemForm {
    margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserTeacherInfo.vue